import { Stack, Typography, useTheme } from "@mui/material";
import { FC, useState } from "react";
import { ConfirmationDialog, CustomTabs } from "../../../components";
import { useLocalization } from "../../../hooks/useLocalization";
import { CreateDemoUserForm } from "./CreateDemoUserForm";
import { InviteUserForm } from "./InviteUserForm";
import { AddNewUserDialogProps } from "./types";

export const AddNewUserDialog: FC<AddNewUserDialogProps> = ({
  isAddUserDialogOpen,
  setIsAddUserDialogOpen,
  setIsSuccessDialogOpen,
  setSuccessMessage,
  isSsoCompany,
  demoEmailDomain,
}) => {
  const theme = useTheme();
  const { t } = useLocalization();

  const TABS = [
    { label: t("users.addNewUserDialog.demoAccountTab"), value: 0 },
    { label: t("users.addNewUserDialog.inviteUserTab"), value: 1 },
  ];

  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <ConfirmationDialog.Root
      PaperProps={{
        sx: { width: "100%" },
      }}
      aria-describedby="add-user-description"
      aria-labelledby="add-user-title"
      fullScreenOnMobile={true}
      maxWidth="xs"
      onClose={() => setIsAddUserDialogOpen(false)}
      open={isAddUserDialogOpen}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
        },
      }}
    >
      <ConfirmationDialog.Title id="add-user-title" showIcon={false}>
        <Stack>
          {isSsoCompany
            ? t("users.addNewUserDialog.addDemoAccount")
            : t("users.addNewUserDialog.addNewUser")}
          {!isSsoCompany && (
            <>
              <Typography fontSize={12} sx={{ color: theme.colors.text[1] }}>
                {t("users.addNewUserDialog.subtitle")}
              </Typography>
              <CustomTabs
                activeTab={selectedTab}
                containerSx={{ mb: 1 }}
                onTabChange={handleTabChange}
                tabWidth="50%"
                tabs={TABS}
              />
            </>
          )}
        </Stack>
      </ConfirmationDialog.Title>
      {selectedTab === 0 && (
        <CreateDemoUserForm
          demoEmailDomain={demoEmailDomain}
          setIsAddUserDialogOpen={setIsAddUserDialogOpen}
          setIsSuccessDialogOpen={setIsSuccessDialogOpen}
          setSuccessMessage={setSuccessMessage}
        />
      )}
      {selectedTab === 1 && (
        <InviteUserForm
          setIsAddUserDialogOpen={setIsAddUserDialogOpen}
          setIsSuccessDialogOpen={setIsSuccessDialogOpen}
          setSuccessMessage={setSuccessMessage}
        />
      )}
    </ConfirmationDialog.Root>
  );
};
